export const GET_NOTIFY = "notify/getNotify";
export const UPDATE_READ_NOTIFY = "notify/updateNotify";
export const UPDATE_LIST_READ_NOTIFY = "notify/updateListNotify";
